import React from 'react'
import styles from './styles.module.css'

export const KnowledgeKey = () => {
  return (
    <div className={styles.legendWrapper}>
      <div className={styles.legend}>
        <h3>Knowledge Categories</h3>
        <ul>
          {/* Databases - Blue tones */}
          <li><span className={styles.legendDot} style={{background: '#4169E1'}}></span>Databases</li>
          
          {/* Programming Languages - Green tones */}
          <li><span className={styles.legendDot} style={{background: '#32CD32'}}></span>Programming Languages</li>
          
          {/* Development Tools - Purple tones */}
          <li><span className={styles.legendDot} style={{background: '#9370DB'}}></span>Development Tools</li>
          
          {/* Web Technologies - Cyan tones */}
          <li><span className={styles.legendDot} style={{background: '#00CED1'}}></span>Web Technologies</li>
          
          {/* Cloud/Infrastructure - Orange tones */}
          <li><span className={styles.legendDot} style={{background: '#FFA500'}}></span>Cloud/Infrastructure</li>
          
          {/* Testing Tools - Red tones */}
          <li><span className={styles.legendDot} style={{background: '#99425B'}}></span>Testing Tools</li>
          
          {/* State Management - Purple */}
          <li><span className={styles.legendDot} style={{background: '#764ABC'}}></span>State Management</li>
          
          {/* Backend Runtime - Special green */}
          <li><span className={styles.legendDot} style={{background: '#66CC33'}}></span>Backend Runtime</li>
          
          {/* Security & Protocols - Orange */}
          <li><span className={styles.legendDot} style={{background: '#FF8C00'}}></span>Security & Protocols</li>
        </ul>
      </div>
    </div>
  )
} 